import { useState } from 'react'

export type ModalControls = {
  modal: string
  modalOpen: boolean
  setModalOpen: (v: boolean) => void
  handleModalOpen: (v: string) => void
  handleModalClose: () => void
}
export const useModalControl = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [modal, setModal] = useState<string>('')

  const handleModalOpen = (name: string) => {
    setModal(name)
    setModalOpen(true)
  }

  const handleModalClose = () => {
    setModal('')
    setModalOpen(false)
  }

  return { modal, modalOpen, setModalOpen, handleModalOpen, handleModalClose }
}
